import Base from './Base';

class Profile extends Base {
    update(data, opts = null) {
        return this.postJSONWithSession<User>('/profile', data, opts);
    }

    avatar(url, opts = null) {
        return this.postJSONWithSession<User>(
            '/profile/avatar',
            {
                url,
            },
            opts,
        );
    }

    updateContact(data, opts = null) {
        return this.postJSONWithSession<User>('/profile/contacts', data, opts);
    }

    verifyContact({ id: contactId }: UserContact, data = null, opts = null) {
        return this.postJSONWithSession<User>(`/profile/contacts/${contactId}/verify`, data, opts);
    }

    cancelContact({ id: contactId }: UserContact, data = null, opts = null) {
        return this.postJSONWithSession<User>(`/profile/contacts/${contactId}/cancel`, data, opts);
    }

    delete(data, opts = null) {
        return this.postJSONWithSession<{ success: boolean }>(
            '/profile',
            {
                _method: 'DELETE',
                ...data,
            },
            opts,
        );
    }
}

export default Profile;
